export default __webpack_public_path__ + "static/media/eva_more-vertical-fill.1aa0ebf1.svg";